
<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="purchase_add_container mobile_container"  v-loading="loading">
            <CustomFormMobile
                    ref="purchase_custom_form"
                    :field_list="formInfoList"
                    :form_detail="purchaseFormData"
                    :pk_id="purchaseId"
                    :is_form_module="true"
                    @submit-form="submitFormData"
                    v-if="dataLoaded"
            />

            <div class="add_approval_select_process">
                <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list"></approveProcessSelect>
            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>

    </div>
</template>

<script>
import {PurchaseDetail,getFormFields,getApprovalNodes,PurchaseAdd} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
export default {
    name: "purchase_edit",
    components: {ReturnNavBar,CustomFormMobile,approveProcessSelect},
    data() {
        return {
            loading: false,
            purchaseId:0,
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
            purchaseFormData:{},
            approval_node_list:[]
        };
    },
    created() {
        this.purchaseId = this.$route.query.purchase_id
        this._getFromFields();
    },
    methods: {
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "purchases",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    if(this.purchaseId){
                        this.getPurchaseDetail()
                    }
                    this.getApprovalNodes()
                }
            });
        },
        // 获取详情
        getPurchaseDetail(){
            PurchaseDetail({
                purchase_id: this.purchaseId
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseFormData = res.data
                    this.dataLoaded = true
                } else {
                    this.$toast(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取审批流
        getApprovalNodes(only = false){
            this.approval_node_list = []
            getApprovalNodes({
                approval_type: 'purchase',
            }).then(res => {
                if (res.code === 200) {
                    this.approval_node_list = res.data
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                } else {
                    this.$toast(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleClickConfirm() {
            this.$refs.purchase_custom_form.handleClickPublish();
        },
        submitFormData(customForm) {
            if (customForm) {
                let flag = false
                customForm.purchase_details.forEach((item,index)=>{
                    if(!item.product_name || !item.num || item.price == ''){
                        flag = true
                    }
                })
                if(flag){
                    this.$toast('请把采购明细填写完整')
                    return false
                }

                if(this.$refs.approveProcessSelectRef.handleClickPublish() == false){  //审批节点校验没通过
                    return false
                }
                // 预付款金额 ==  0或不填写时为全款支付
                if(customForm && customForm.prepayment_price.value == '' || customForm.prepayment_price.value == 0){
                    this.$set(customForm.prepayment_price,'text',customForm.total_price.text)
                    this.$set(customForm.prepayment_price,'value',customForm.total_price.value)
                }
                if(customForm && customForm.pre_due_date && customForm.pre_due_date.value == ''){
                    this.$set(customForm.pre_due_date,'value',null)
                }
                this.BtnDisabled = true;
                customForm.node_list = this.approval_node_list
                PurchaseAdd(customForm).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$router.go(-1);
                                this.BtnDisabled = false;
                            },
                        });
                    } else {
                        this.$toast({
                            message: res.message,
                            type: "fail",
                        });
                        this.BtnDisabled = false;
                    }
                }).catch(() => {
                    this.BtnDisabled = false;
                })
            }

        }


    },
};
</script>

<style lang="scss" scoped>
.custom_form_wrap{
    height: auto;
}
.purchase_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;

}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}
.add_approval_select_process{
    padding: 10px 16px;
    background: #fff;
}
</style>
